import React from 'react';

import { observer } from 'mobx-react';
import { Divider, InfoBox, TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './PaymentDetailsWidget.module.scss';

import { TitledInfo } from '../../../../../shared/components/ui-components';
import {
  GridTableCell,
  GridTableRow,
} from '../../../../../shared/components/table-components';
import { currentSubscriptionPlanStore } from '../../../../stores/currentSubscriptionPlanStore';
import { getFormattedLocalDate } from '../../../../../shared/utils/dateUtils';
import { localDataFormat } from '../../../../../shared/constants/apiDateFormat';
import { getHumanizeBillingPeriodType } from '../../../../utils/getHumanizeBillingPeriodType/getHumanizeBillingPeriodType';
import { PaymentActionRow } from './PaymentActionRow/PaymentActionRow';

type PaymentDetailsWidgetProps = {
  customerId: number;
  entityId: number;
};

const PaymentDetailsWidget = observer(
  ({ customerId, entityId }: PaymentDetailsWidgetProps) => {
    const { currentSubscriptionPlan, paymentStatusFlag } = currentSubscriptionPlanStore;

    if (!currentSubscriptionPlan) {
      return null;
    }
    const { lastTransaction, explorePlan } = currentSubscriptionPlan;
    const { billingInfo } = lastTransaction;

    const formattedNextBillingDate = getFormattedLocalDate(
      billingInfo.nextBillingDateTime,
      localDataFormat,
    );

    const formattedActiveSinceDate = getFormattedLocalDate(
      billingInfo.activeSinceDateTime,
      localDataFormat,
    );

    return (
      <InfoBox title="Payment Details" customContentPadding>
        <div className={classes.paymentDetailsTableView}>
          <GridTableRow variant="unstyled" className={classes.billInfoRow}>
            <GridTableCell variant="title">Billing Info</GridTableCell>
            <GridTableCell className="private-info">
              <p>{billingInfo.customerName}</p>
              <p>{billingInfo.billingEmail}</p>
            </GridTableCell>
          </GridTableRow>
          <Divider className={classes.divider} />
          <GridTableRow variant="unstyled" className={classes.billingDatesRow}>
            <GridTableCell>
              <TitledInfo title="Billing Period">
                {!paymentStatusFlag.CANCELED && (
                  <TitleWithDescription
                    title={
                      billingInfo.billingPeriodType &&
                      getHumanizeBillingPeriodType(billingInfo.billingPeriodType)
                    }
                    description={
                      billingInfo.nextBillingDate &&
                      `Next billing date: ${formattedNextBillingDate}`
                    }
                    titleFont="inherit"
                    direction="row"
                    className="private-info"
                  />
                )}
                {paymentStatusFlag.CANCELED && explorePlan && (
                  <div>{getHumanizeBillingPeriodType(explorePlan.billingPeriodType)}</div>
                )}
              </TitledInfo>
            </GridTableCell>
            <GridTableCell>
              <TitledInfo title="Active Since">
                {billingInfo.activeSinceDate && !paymentStatusFlag.CANCELED && (
                  <div>{formattedActiveSinceDate}</div>
                )}
              </TitledInfo>
            </GridTableCell>
          </GridTableRow>
          <PaymentActionRow customerId={customerId} entityId={entityId} />
        </div>
      </InfoBox>
    );
  },
);

export { PaymentDetailsWidget };
